<div class="auth-login position-relative overflow-hidden d-flex align-items-center justify-content-center px-7 px-xxl-0 rounded-3 h-n20">
    <div class="auth-login-shape position-relative w-100">
        <div class="auth-login-wrapper card mb-0 container position-relative z-1 h-100 mh-n100" data-simplebar>
            <div class="card-body">
                <!--
                <a href="/" class="">
                    <img src="../assets/images/logos/logo-dark.svg" class="light-logo" alt="Logo-Dark" />
                    <img src="../assets/images/logos/logo-light.svg" class="dark-logo" alt="Logo-light" />
                </a>
                -->
                <div class="row align-items-center justify-content-center pt-6 pb-5">
                    <div class="col-lg-6 col-xl-5">
                        <!-- Loading -->
                        <div data-id="token-loading" class="text-center py-7">
                            <div class="spinner-border text-primary mb-3" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <p class="fs-4 text-muted">Validating token...</p>
                        </div>

                        <!-- Success -->
                        <div data-id="token-success" style="display: none;">
                            <div class="text-center mb-5">
                                <iconify-icon icon="solar:check-circle-bold-duotone" class="text-success" style="font-size: 64px;"></iconify-icon>
                            </div>
                            <h3 data-id="token-success-title" class="mb-3 text-center">Token Valid</h3>
                            <p data-id="token-success-message" class="text-muted text-center fs-4 mb-5"></p>
                            <div class="text-center">
                                <a href="/login" class="btn btn-primary rounded-pill">Go to Login</a>
                            </div>
                        </div>

                        <!-- Error: Not Found -->
                        <div data-id="token-not-found" style="display: none;">
                            <div class="text-center mb-5">
                                <iconify-icon icon="solar:close-circle-bold-duotone" class="text-danger" style="font-size: 64px;"></iconify-icon>
                            </div>
                            <h3 class="mb-3 text-center">Token Not Found</h3>
                            <p class="text-muted text-center fs-4 mb-5">This token does not exist or has already been used.</p>
                            <div class="text-center">
                                <a href="/login" class="btn btn-primary rounded-pill">Go to Login</a>
                            </div>
                        </div>

                        <!-- Error: Expired -->
                        <div data-id="token-expired" style="display: none;">
                            <div class="text-center mb-5">
                                <iconify-icon icon="solar:clock-circle-bold-duotone" class="text-warning" style="font-size: 64px;"></iconify-icon>
                            </div>
                            <h3 class="mb-3 text-center">Token Expired</h3>
                            <p class="text-muted text-center fs-4 mb-5">This token has expired. Please request a new one.</p>
                            <div class="text-center">
                                <a href="/login" class="btn btn-primary rounded-pill">Go to Login</a>
                            </div>
                        </div>

                        <!-- Password Reset Form -->
                        <div data-id="token-password-reset" style="display: none;">
                            <h2 class="mb-6 fs-8 fw-bolder">Set a New Password</h2>
                            <p class="text-dark fs-4 mb-7">Enter your new password below. It must be at least 6 characters long.</p>
                            <form data-id="form-password-reset">
                                <div class="mb-7">
                                    <label for="resetPassword" class="form-label fw-bold">New Password</label>
                                    <input type="password"
                                           class="form-control py-6"
                                           id="resetPassword"
                                           name="password"
                                           minlength="6"
                                           required>
                                </div>
                                <div class="mb-9">
                                    <label for="resetPasswordConfirm" class="form-label fw-bold">Confirm Password</label>
                                    <input type="password"
                                           class="form-control py-6"
                                           id="resetPasswordConfirm"
                                           name="passwordConfirm"
                                           minlength="6"
                                           required>
                                    <div class="invalid-feedback">Passwords do not match.</div>
                                </div>
                                <button data-id="btn-password-reset"
                                        type="button"
                                        class="btn btn-primary w-100 mb-3 rounded-pill">Reset Password</button>
                                <button data-id="btn-password-reset-loading"
                                        class="btn btn-primary w-100 mb-3 rounded-pill"
                                        type="button"
                                        style="display: none;"
                                        disabled="">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...
                                </button>
                                <div data-id="password-reset-error-container"
                                     class="invalid-feedback mb-3"></div>
                                <a href="/login" class="btn bg-primary-subtle text-primary w-100 rounded-pill">Back to Login</a>
                            </form>
                        </div>

                        <!-- Password Reset Success -->
                        <div data-id="token-password-reset-success" style="display: none;">
                            <div class="text-center mb-5">
                                <iconify-icon icon="solar:check-circle-bold-duotone" class="text-success" style="font-size: 64px;"></iconify-icon>
                            </div>
                            <h3 class="mb-3 text-center">Password Reset Successfully</h3>
                            <p class="text-muted text-center fs-4 mb-5">Your password has been updated. You can now log in with your new password.</p>
                            <div class="text-center">
                                <a href="/login" class="btn btn-primary rounded-pill">Go to Login</a>
                            </div>
                        </div>

                        <!-- Error: Generic -->
                        <div data-id="token-error" style="display: none;">
                            <div class="text-center mb-5">
                                <iconify-icon icon="solar:danger-triangle-bold-duotone" class="text-danger" style="font-size: 64px;"></iconify-icon>
                            </div>
                            <h3 class="mb-3 text-center">Something Went Wrong</h3>
                            <p data-id="token-error-message" class="text-muted text-center fs-4 mb-5">An unexpected error occurred.</p>
                            <div class="text-center">
                                <a href="/login" class="btn btn-primary rounded-pill">Go to Login</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="dark-transparent sidebartoggler"></div>
